import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { Empty } from "../../Empty";
import { AppDialogDispatcher } from "../dialogs/AppDialogDispatcher";
import { selectUser } from "./userSlice";

type AuthorizeProps = {
    children: ReactNode
};

export const Authenticate = (props: AuthorizeProps) => {
    const user = useAppSelector(selectUser)
    const location = useLocation()
    const navigate = useNavigate()

    const { tokenState } = user

    useEffect(() => {
        if (tokenState !== undefined) {
            if (tokenState.tag === 'invalid') {
                navigate({
                    pathname: '/login',
                }, {
                        state: {
                            prevLocation: location,
                        },
                })
            } else if (tokenState.tag === 'empty' && tokenState.reason === 'logout') {
                // explicit logout - the next user may be someone else, don't send them back here
                navigate('/login', { replace: true })
            } else if (tokenState.tag === 'empty') {
                navigate({
                    pathname: '/login',
                }, {
                        state: {
                            prevLocation: location,
                        },
                })
            }
        }
    }, [tokenState, location])

    if (tokenState === undefined) return <Empty />

    switch (tokenState.tag) {
        case "valid":
        case "invalid":
            return <>
                {props.children}
                <AppDialogDispatcher />
            </>
        case "empty":
            return (<Empty />);
        default:
            return (<Empty />);
    }
}
